import { Switch } from "@/components/ui/switch";

/* eslint-disable @typescript-eslint/no-explicit-any */
export const DownloadAttachmentFromUrl = ({
  row,
  inlineUpdate,
  activePermission,
}: {
  row: any;
  inlineUpdate: any;
  activePermission: any;
}) => {
  console.log({ row });
  const currentDta = row?.originData;
  return (
    <div>
      <Switch
        checked={
          currentDta.settings?.download_attachment_from_url ? true : false
        }
        onCheckedChange={(prop) => {
          const updatedData = {
            ...currentDta,
            settings: {
              ...currentDta.settings,
              download_attachment_from_url: prop,
            },
          };
          console.log({ updatedData });
          inlineUpdate(updatedData);
        }}
        disabled={activePermission?.update !== true}
      />
    </div>
  );
};
